/**
 * Temporarily disabled plans
 */
const DISABLED_PLANS: Record<string, string> = {};

/**
 * Check if a plan is temporarily disabled
 * @param planSlug - The subscription plan slug
 * @returns Object with disabled status and reason if disabled
 */
export function getDisabledPlanInfo(planSlug: string): { disabled: boolean; reason?: string } {
  const slug = planSlug.toLowerCase();
  const reason = DISABLED_PLANS[slug];

  if (reason) {
    return { disabled: true, reason };
  }

  return { disabled: false };
}
